@if(isLoggedIn && count > 0) {
	<span (click)="openModal()" class="phb-icon btn-zip icon--folder" [title]="'DocumentPool.Title' | translate:systemLanguage"></span>
	<div class="fileCount">{{count}}</div>
}


